export class CachedPromise<T> {
	private data: any;
	private dataLoaded: boolean = false;
	private promise: Promise<T>|null = null;
	private factory: (resolve: (data: T) => void) => (Promise<T> | null);

	constructor(factory : (resolve: (data : T) => void) => null|Promise<T>) {
		this.factory = factory;
	}

	public fetch(): Promise<T> {
		return new Promise<T>(resolve => {
			if (this.data) resolve(this.data);
			else {
				if (!this.promise) this.promise = new Promise<T>((resolve) => this.factory(resolve)?.then(data => resolve(data)));
				this.promise.then(res => {
					this.data = res;
					resolve(this.data);
				});
			}
		});
	}
}